import { Validations } from '../utils';

const SuperUser = 'superuser';
const Sales = 'sales';
const Dealer = 'dealer';

const isAGIUser = (authUser, rolesKey) =>
  Validations.hasRole(authUser, rolesKey, [SuperUser, Sales]);

// coming from Auth0 role names - changable
// keeping this here to be able to change at once, but not limited to these
export { SuperUser, Sales, Dealer, isAGIUser };



// WEBPACK FOOTER //
// ./src/auth/AuthRoles.js